/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import { Modal } from 'antd-mobile'
import { observer } from 'mobx-react'
import { ModalBg } from '@styles/base.style'
import { Button, PopupBtnStyle, ButtonWrap } from '@styles/button.style'
// css
import { PopupTxt } from '../../index.style'

interface AllDeletePopupProps {
  visible: boolean
  setVisible: (arg: boolean) => void
  onDelete?: () => void
  messageType?: string
}

const AllDeletePopup: React.FC<AllDeletePopupProps> = (props: AllDeletePopupProps) => {
  const { visible, setVisible, onDelete, messageType } = props
  const onClickCancelButton = () => setVisible(false)
  const onClickDeleteButton = () => onDelete()
  const onClickDeleteAllMessagePopupCloseButton = () => setVisible(false)

  return (
    <Modal
      transparent
      className="normal-dialog"
      visible={visible}
      maskClosable={false}
      onClose={onClickDeleteAllMessagePopupCloseButton}
      title={`${messageType || '메시지'} 전체삭제`}
    >
      <PopupTxt>
        삭제 후 복원이 불가능합니다.
        <br />
        삭제하시겠습니까?
      </PopupTxt>
      <ButtonWrap>
        <Button css={PopupBtnStyle} className="two-button cancel dialog" onClick={onClickCancelButton}>
          취소
          </Button>
        <Button css={PopupBtnStyle} onClick={onClickDeleteButton} className="two-button dialog">
          삭제
          </Button>
      </ButtonWrap>

      <ModalBg onClick={onClickDeleteAllMessagePopupCloseButton} />
    </Modal>
  )
}
export default observer(AllDeletePopup)
